<script>
import Layout from '@layouts/main.vue'
import BaseButtonAngle from '@/src/components/_base-button-angle.vue'
import SubNav from '@/src/components/sub-nav.vue'
import PopOver from '@/src/components/pop-over.vue'

export default {
  page: {
    title: '02 01 Planning Location A',
    meta: [
      { name: 'description', content: 'The 02 00 Planning Location Page.' },
    ],
  },
  components: { Layout, BaseButtonAngle, SubNav, PopOver },
}
</script>

<template>
  <Layout>
    <BaseBgComponent img-u-r-l="2.1_planning.jpg" />
    <SubNav>
      <BaseButtonAngle clip-side="Right" click-active="inactive">
        <span>Path 04</span><br />
        Material Movement
      </BaseButtonAngle>
    </SubNav>
    <PopOver
      :pos-x="10"
      :pos-y="25"
      pos-unit="%"
      pop-size="md"
      pop-height="200px"
      pop-color="white"
    >
      <h2 class="m-t-5 m-b-15 p-b-15" style="border-bottom: solid 2px #fff;"
        >04 | Material Movement <span>Location A</span></h2
      >
      <h3 class="m-t-5" style="font-weight: normal;">
        From strategic to operational plans, Hexagon improves your efficiency
        with a seamless flow of information.
      </h3>
    </PopOver>
    <BaseHotspot
      spot-size="large"
      :pos-x="30"
      :pos-y="40"
      pos-unit="%"
      :rot-x="57"
    />
  </Layout>
</template>
